// extracted by mini-css-extract-plugin
module.exports = {"btns-wrapper":"styles_btns-wrapper__2jSEK","modal-error":"styles_modal-error__2zFIl","picker-wrapper":"styles_picker-wrapper__24dz1","btn-fixed":"styles_btn-fixed__2Ppml"};